import React from 'react';
import './NewsView.scss';
import TaskNews from '../../ws/TaskNews';
import PopUpFilter from './components/PopUpFilter/PopUpFilter';
import PopUpNews from './components/PopUpNews/PopUpNews';
import PopUpVideo from './components/PopUpVideo/PopUpVideo';
import PopUpImages from '../common/components/PopUpImages/PopUpImages';
import { withTranslation, WithTranslation } from 'react-i18next';
import { translate } from '../../../I18n/i18n';
import { Post, PostDetail } from '../../model/domain/news';
import { User } from '../../model/domain/user';
import PopUpRemove from '../common/components/PopUpRemove/PopUpRemove';
import { Media } from '../../model/domain/media';
import { EmptyContentText } from '../common/components/EmptyContentText/EmptyContentText';
import NewsCard from './components/NewsCard/NewsCard';
import NewsCardProfilePicture from './components/NewsCardProfilePicture/NewsCardProfilePicture';
import { ShareCenterOption } from '../../model/domain/share-option';

interface NewsViewProps extends WithTranslation{
    posts: Post[];
    media:{ [key: number]: {[key:number]: string | null} | null };
    onFilterSubmit: (filters: { dateFrom: string; dateTo: string; types: string }) => void;
    user: User;
    updatePosts: (postId: number, totalLikes: any, userLike: {likeTypeId: number, likeTypeName: string}) => void;
    updateView: () => void;
}

interface NewsViewState {
    colors: { [key: string]: string };
    showReactions: { [key: number]: boolean };
    showPopupFilter: boolean;
    showPopupRemove: boolean;
    postToRemove: number;
    showPopupCreate: boolean;
    postToEdit: PostDetail | undefined;
    showPopupVideo: boolean;
    mediaId: number;
    showImagePopup: boolean;
    selectedImageIndex: number;
    mediaArray: Array<Media>;
    posts: Post[];
    loadingPostDetail: boolean;
}

class NewsView extends React.Component<NewsViewProps, NewsViewState> {

    private taskNews: TaskNews;
    childRef = React.createRef<typeof PopUpNews>();

    constructor(props: NewsViewProps) {
        super(props);
        this.childRef = React.createRef();
        this.state = {
            colors: {},
            showReactions: {},
            showPopupFilter: false,
            showPopupRemove: false,
            postToRemove: 0,
            showPopupCreate: false,
            postToEdit: undefined,
            showPopupVideo: false,
            mediaId: 0,
            showImagePopup: false,
            selectedImageIndex: 0,
            mediaArray: [],
            posts: props.posts,
            loadingPostDetail: false
        };
        this.taskNews = new TaskNews();
    }

    componentDidUpdate(prevProps: NewsViewProps) {
        const { loadingPostDetail } = this.state;
        document.body.style.overflow = loadingPostDetail
            ? 'hidden'
            : '';

        if (prevProps.posts !== this.props.posts) {
            this.setState({ posts: this.props.posts });
        }
    }

    private updatePostLikes = (updatedPost: Post) => {
        this.setState(prevState => ({
            posts: prevState.posts.map(post =>
                post.id === updatedPost.id ? updatedPost : post
            )
        }));
        this.props.updatePosts(updatedPost.id, updatedPost.total_likes, updatedPost.user_like);
    };

    private handleLike = (post: Post, likeTypeId: number) => {
        // Comprobar si ya existe una reacción del usuario
        if (post.user_like) {
            // Comprobar si el likeTypeId actual es igual al nuevo
            if (post.user_like.likeTypeId === likeTypeId) {
                // Eliminar la reacción si es el mismo tipo
                this.taskNews.removeReaction(post.id).then(response => {
                    console.log('Reacción eliminada');
                    this.updatePostLikes(response.news);
                }).catch(error => {
                    console.error('Error al eliminar la reacción:', error);
                });
            } else {
                // Guardar la nueva reacción si el tipo es diferente
                this.taskNews.saveReaction(post.id, likeTypeId).then(response => {
                    console.log('Reacción actualizada:', response);
                    this.updatePostLikes(response.news);
                }).catch(error => {
                    console.error('Error al actualizar la reacción:', error);
                });
            }
        } else {
            // Crear una nueva reacción si no existe ninguna
            this.taskNews.saveReaction(post.id, likeTypeId).then(response => {
                console.log('Nueva reacción guardada:', response);
                this.updatePostLikes(response.news);
            }).catch(error => {
                console.error('Error al guardar la nueva reacción:', error);
            });
        }
    }    

    private togglePopupFilter = () => {
        this.setState(prevState => ({
            showPopupFilter: !prevState.showPopupFilter
        }));
    };

    private togglePopupRemove = (postId: number) => {
        console.log("postId para eliminar:", postId);
        console.log("showPopupRemove", this.state.showPopupRemove);
        this.setState(prevState => ({
            showPopupRemove: !prevState.showPopupRemove,
            postToRemove: postId,
        }));
    };

    private togglePopupCreate = async (post: Post | undefined) => {
        try {
            console.log(post)
            let postToEdit;
            if (post) {
                this.setState({ loadingPostDetail: true });
                postToEdit = await this.taskNews.getNewsDetail(post.id);
                this.setState({ loadingPostDetail: false });
            }
            this.setState(prevState => ({
                showPopupCreate: !prevState.showPopupCreate,
                postToEdit
            }));
        } catch (err) {
            this.setState({ loadingPostDetail: false });
            console.log('Error obteniendo detalle de noticia', err);
            alert(translate(this.props.t, 'news.TR_ERROR_GETTING_NEWS_DETAIL'));
        }
    };

    private togglePopupVideo = (mediaId: number) => {
        this.setState(prevState => ({
            showPopupVideo: !prevState.showPopupVideo,
            mediaId: mediaId | 0
        }));
    };

    private togglePopupImages = (index: number, mediaArray: Array<Media>) => {
        console.log("index en togglePopupImages: " + index)
        this.setState(prevState => ({
            showImagePopup: !prevState.showImagePopup,
            selectedImageIndex: prevState.showImagePopup ? -1 : index,  // Resetea el índice al cerrar el popup
            mediaArray: mediaArray
        }));
    };

    // En NewsView, dentro del método handlePopupSubmit
    handlePopupSubmit = (filters: { dateFrom: string; dateTo: string; contentType: string }) => {
        // Aquí cambiamos 'contentType' por 'types' para que coincida con el tipo esperado
        const updatedFilters = {
            dateFrom: filters.dateFrom,
            dateTo: filters.dateTo,
            types: filters.contentType // Asegúrate de mapear 'contentType' a 'types'
        };

        // Enviar los filtros al componente padre (NewsContainer)
        this.props.onFilterSubmit(updatedFilters);
    };

    private handleRemovePost = () => {
        const { postToRemove } = this.state;

        if (postToRemove) {
            this.taskNews.removePost(postToRemove)
                .then(() => {
                    console.log('Post eliminado');
                    this.setState({ showPopupRemove: false, postToRemove: 0 });
                    setTimeout(() => {
                        window.location.reload();
                    }, 0);
                })
                .catch((error: any) => {
                    console.error('Error al eliminar el post:', error);
                    this.setState({ showPopupRemove: false, postToRemove: 0 });
                    alert(translate(this.props.t, 'news.TR_ERROR_DELETING_POST') + error.message);
                });
        }
    };

    private handlePopUpNews = (postContent: { content: string; media: File[] | File; isForAllCenters: string; publishingDate: string | null, isCreate: boolean; mediaType: string | null, shareOptions: ShareCenterOption[] }) => {
        return new Promise<void>((resolve, reject) => {
            const { postToEdit } = this.state;
            const isCreate = postContent.isCreate; // Usar isCreate pasado desde el PopUpNews

            // Crear el objeto con los datos del post que se van a enviar
            const postData = {
                content: postContent.content,
                shareOptions: postContent.shareOptions,
                publishingDate: postContent.publishingDate,
                isForAllCenters: postContent.isForAllCenters,  // Se mantiene como string 'true'/'false'
                mediaType: postContent.mediaType,              // 'images' o 'video'
                // Se maneja media dependiendo si es un archivo o un arreglo
                media: Array.isArray(postContent.media) && postContent.media.length > 0
                    ? postContent.media
                    : postContent.media instanceof File
                        ? [postContent.media]  // Si es un solo archivo (video), lo pasamos como un arreglo
                        : undefined
            };

            if (isCreate) {
                // Crear un nuevo post
                this.taskNews.createNews(postData)
                    .then(() => {
                        this.setState({ showPopupCreate: false, postToEdit: undefined });
                        window.location.reload(); // Recargar la página para mostrar el nuevo post
                        resolve();
                    })
                    .catch(error => {
                        console.error('Error al crear el post:', error);
                        alert(translate(this.props.t, 'common.TR_ERROR_CREATING_POST') + error.message);
                        reject();
                    });
            } else {
                // Editar un post existente
                if (postToEdit) {
                    const updatedPostData = {
                        ...postData,
                        id: postToEdit.id, // Añadir el id del post a editar
                    };

                    this.taskNews.editNews(postToEdit.id, updatedPostData)
                        .then(() => {
                            console.log('Post editado');
                            this.props.updateView();
                            this.resetChildState();
                            this.setState({ showPopupCreate: false, postToEdit: undefined });
                            resolve();
                        })
                        .catch(error => {
                            console.error('Error al editar el post:', error);
                            alert(translate(this.props.t, 'common.TR_ERROR_EDITING_POST') + error.message);
                            reject();
                        });
                }
            }
        });
    };

    resetChildState = () => {
        // Llamar a resetState() del componente hijo si la referencia existe
        if (this.childRef.current) {
            (this.childRef.current as any).resetState();
        }
    }

    public renderPost(post: Post): React.ReactNode {
        return <NewsCard
            post={post}
            user={this.props.user}
            media={this.props.media}
            showReactions={this.state.showReactions}
            onEdit={this.togglePopupCreate}
            onDelete={this.togglePopupRemove}
            onViewImages={this.togglePopupImages}
            onViewVideo={this.togglePopupVideo}
            onLike={this.handleLike}
            onEnterReactions={() => this.setState({ showReactions: { [post.id]: true } })}
            onLeaveReactions={() => this.setState({ showReactions: { [post.id]: false } })}
        />
    }

    public render() {
        const {
            posts,
            showPopupFilter,
            showPopupRemove,
            showPopupCreate,
            postToEdit,
            showPopupVideo,
            mediaId,
            showImagePopup,
            selectedImageIndex,
            mediaArray,
            loadingPostDetail
        } = this.state;
        const { t } = this.props;

        return (
            <div className="container">
                {this.props.user.data.createNewsPermission ? (
                    <>
                        <div className="card-news shadow mb-3" onClick={() => this.togglePopupCreate(undefined)}>
                            <div className="card-body">
                                <div className='card-container-header'>
                                    <div
                                        className='card-image-profile'
                                        style={{ backgroundColor: this.props.user.data.profileColor }}
                                    >
                                        <NewsCardProfilePicture
                                            fullName={this.props.user.data.fullName}
                                            profilePicture={this.props.user.data.profilePicturePath}
                                        />
                                    </div>
                                    <p className="card-text-create text-muted">{translate(t, 'news.TR_PLACEHOLDER_CREATE_NEWS_LABEL')}</p>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}

                <div className="d-flex justify-content-start mb-3">
                    <button className="btn btn-outline-secondary d-flex align-items-center btn-filter" style={{ textTransform: 'none' }} onClick={this.togglePopupFilter}>
                        <i className="fas fa-filter me-2"></i>
                        {translate(t, 'news.TR_FILTER_LABEL')}
                    </button>
                </div>

                <PopUpFilter
                    show={showPopupFilter}
                    onClose={this.togglePopupFilter}
                    onSubmit={this.handlePopupSubmit}
                />

                <PopUpRemove
                    show={showPopupRemove}
                    onClose={() => this.setState({ showPopupRemove: false, postToRemove: 0 })}
                    onSubmit={this.handleRemovePost}
                />

                <PopUpNews
                    show={showPopupCreate}
                    onClose={this.togglePopupCreate}
                    onSubmit={this.handlePopUpNews}
                    post={postToEdit}
                    taskNewsService={this.taskNews}
                    user={this.props.user}
                    ref={this.childRef}
                />

                <PopUpVideo
                    show={showPopupVideo}
                    onClose={() => this.togglePopupVideo(0)}
                    mediaId={mediaId}
                />

                <PopUpImages
                    show={showImagePopup}
                    onClose={() => this.togglePopupImages(0, [])}
                    mediaArray={mediaArray}
                    selectedImageIndex={selectedImageIndex}
                />

                {posts.length === 0 ? (
                    <EmptyContentText
                        message={translate(t, 'news.TR_NO_POSTS_LABEL')}
                    />
                ) : (
                    posts.map(post => this.renderPost(post))
                )}

                {loadingPostDetail ? (
                    <div className="loading-news-container">
                        <p className="loading-news-text">{translate(t, 'news.TR_LOADING_LABEL')}</p>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default withTranslation()(NewsView);
